import React from "react";
import {useTranslation} from "react-i18next";
import { motion } from "framer-motion";
import { fadeInLeft, fadeInRight, staggerContainer, staggerItem, buttonVariants, floatingIconVariants } from "../../utility/framerMotionAnimations";

const CommercialVehicleChooseUsSection = ({content, onApplyNowClick})=>{
    const {t} =useTranslation('commercialVehicleLoanPage');
    return(
        <>
        <section className="section-container">
            <div className="commercial-vehicle-choose-us-section">
                <motion.div 
                    className="commercial-vehicle-choose-us-section-left"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                    variants={fadeInLeft}
                >
                    <motion.div 
                        className="commercial-vehicle-choose-us-section-left-content"
                        variants={fadeInLeft}
                    >
                    {t('commercial-vehicle-choose-us-section-heading')}
                    <motion.div
                        variants={fadeInLeft}
                        transition={{ delay: 0.2 }}
                    >
                        {content}
                    </motion.div>
                    <motion.button 
                        className="btn-big btn-primary" 
                        onClick={onApplyNowClick}
                        variants={buttonVariants}
                        whileHover="hover"
                        whileTap="tap"
                        transition={{ delay: 0.4 }}
                    >
                        {t('commercial-vehicle-choose-us-section-button')} &#8594;
                    </motion.button>
                    <motion.img 
                        src="/images/airplane-layout.png" 
                        alt="aero-image"
                        className="commercial-vehicle-choose-us-section-left-content-img"
                        variants={fadeInLeft}
                        transition={{ delay: 0.6 }}
                    />
                    </motion.div>
                </motion.div>
                <motion.div 
                    className="commercial-vehicle-choose-us-section-right"
                    variants={staggerContainer}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                >
                    <div className="commercial-vehicle-choose-us-section-right-content">
                        <motion.div 
                            className="commercial-vehicle-choose-us-section-right-content-box"
                            variants={staggerItem}
                        >
                            <div className="commercial-vehicle-choose-us-section-right-content-box-img">
                                <motion.img 
                                    src="/images/fast-loan-approvals-icon.png" 
                                    alt=""
                                    variants={floatingIconVariants}
                                    animate="animate"
                                    style={{ background: 'transparent', backgroundColor: 'transparent' }}
                                />
                                </div>
                            <div className="commercial-vehicle-choose-us-section-right-content-box-title">{t('commercial-vehicle-choose-us-section-box1')}</div>

                        </motion.div>
                        <motion.div 
                            className="commercial-vehicle-choose-us-section-right-content-box box-position"
                            variants={staggerItem}
                        >
                            <div className="commercial-vehicle-choose-us-section-right-content-box-img">
                            <motion.img 
                                src="/images/wide-vehicle-coverage-icon.png" 
                                alt=""
                                variants={floatingIconVariants}
                                animate="animate"
                                style={{ background: 'transparent', backgroundColor: 'transparent' }}
                            />
                            </div>
                            <div className="commercial-vehicle-choose-us-section-right-content-box-title">{t('commercial-vehicle-choose-us-section-box2')}</div>
                        </motion.div>
                        <motion.div 
                            className="commercial-vehicle-choose-us-section-right-content-box"
                            variants={staggerItem}
                        >
                            <div className="commercial-vehicle-choose-us-section-right-content-box-img">
                            <motion.img 
                                src="/images/easy-online-application-icon.png" 
                                alt=""
                                variants={floatingIconVariants}
                                animate="animate"
                                style={{ background: 'transparent', backgroundColor: 'transparent' }}
                            />
                            </div>
                            <div className="commercial-vehicle-choose-us-section-right-content-box-title">{t('commercial-vehicle-choose-us-section-box3')}</div>
                        </motion.div>
                        <motion.div 
                            className="commercial-vehicle-choose-us-section-right-content-box box-position"
                            variants={staggerItem}
                        >
                            <div className="commercial-vehicle-choose-us-section-right-content-box-img">
                            <motion.img 
                                src="/images/tailored-loan-solutuions-icon.png" 
                                alt=""
                                variants={floatingIconVariants}
                                animate="animate"
                                style={{ background: 'transparent', backgroundColor: 'transparent' }}
                            />
                            </div>
                            <div className="commercial-vehicle-choose-us-section-right-content-box-title">{t('commercial-vehicle-choose-us-section-box4')}</div>
                        </motion.div>
                    </div>
                </motion.div>
                
            </div>
        </section>
          {/*Mobile */}
        <section className="card-section-container">
        <motion.div 
            className="commercial-vehicle-choose-us-section-right-mobile"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
        >
                    <div className="commercial-vehicle-choose-us-section-right-mobile-content">
                    <motion.div 
                        className="commercial-vehicle-choose-us-section-right-mobile-content-box"
                        variants={staggerItem}
                    >
                            <div className="commercial-vehicle-choose-us-section-right-mobile-content-box-img">
                                <motion.img 
                                    src="/images/fast-loan-approvals-icon.png" 
                                    alt=""
                                    variants={floatingIconVariants}
                                    animate="animate"
                                    style={{ background: 'transparent', backgroundColor: 'transparent' }}
                                />
                                </div>
                            <div className="commercial-vehicle-choose-us-section-right-mobile-content-box-title"> {t('commercial-vehicle-choose-us-section-box1')}</div>

                        </motion.div>
                        <motion.div 
                            className="commercial-vehicle-choose-us-section-right-mobile-content-box"
                            variants={staggerItem}
                        >
                            <div className="commercial-vehicle-choose-us-section-right-mobile-content-box-img">
                            <motion.img 
                                src="/images/wide-vehicle-coverage-icon.png" 
                                alt=""
                                variants={floatingIconVariants}
                                animate="animate"
                                style={{ background: 'transparent', backgroundColor: 'transparent' }}
                            />
                            </div>
                            <div className="commercial-vehicle-choose-us-section-right-mobile-content-box-title">{t('commercial-vehicle-choose-us-section-box2')}</div>
                        </motion.div>
                        <motion.div 
                            className="commercial-vehicle-choose-us-section-right-mobile-content-box"
                            variants={staggerItem}
                        >
                            <div className="commercial-vehicle-choose-us-section-right-mobile-content-box-img">
                            <motion.img 
                                src="/images/easy-online-application-icon.png" 
                                alt=""
                                variants={floatingIconVariants}
                                animate="animate"
                                style={{ background: 'transparent', backgroundColor: 'transparent' }}
                            />
                            </div>
                            <div className="commercial-vehicle-choose-us-section-right-mobile-content-box-title">{t('commercial-vehicle-choose-us-section-box3')}</div>
                        </motion.div>
                        <motion.div 
                            className="commercial-vehicle-choose-us-section-right-mobile-content-box"
                            variants={staggerItem}
                        >
                            <div className="commercial-vehicle-choose-us-section-right-mobile-content-box-img">
                            <motion.img 
                                src="/images/tailored-loan-solutuions-icon.png" 
                                alt=""
                                variants={floatingIconVariants}
                                animate="animate"
                                style={{ background: 'transparent', backgroundColor: 'transparent' }}
                            />
                            </div>
                            <div className="commercial-vehicle-choose-us-section-right-mobile-content-box-title">{t('commercial-vehicle-choose-us-section-box4')}</div>
                        </motion.div>
                    </div>
                    {/*Add `aria-hidden` to hide the duplicated cards from screen readers.*/}
                        <motion.div 
                            className="ariaihidden commercial-vehicle-choose-us-section-right-mobile-content"
                            variants={staggerItem}
                        >
                            <div className="commercial-vehicle-choose-us-section-right-mobile-content-box">
                                <div className="commercial-vehicle-choose-us-section-right-mobile-content-box-img">
                                <img src="/images/fast-loan-approvals-icon.png" alt=""/>
                                </div>
                                <div className="commercial-vehicle-choose-us-section-right-mobile-content-box-title">{t('commercial-vehicle-choose-us-section-box1')}</div>
                            </div>
                            <div className="commercial-vehicle-choose-us-section-right-mobile-content-box">
                                <div className="commercial-vehicle-choose-us-section-right-mobile-content-box-img">
                                <img src="/images/wide-vehicle-coverage-icon.png" alt=""/>
                                </div>
                                <div className="commercial-vehicle-choose-us-section-right-mobile-content-box-title">{t('commercial-vehicle-choose-us-section-box2')}</div>
                            </div>
                            <div className="commercial-vehicle-choose-us-section-right-mobile-content-box">
                                <div className="commercial-vehicle-choose-us-section-right-mobile-content-box-img">
                                <img src="/images/easy-online-application-icon.png" alt=""/>
                                </div>
                                <div className="commercial-vehicle-choose-us-section-right-mobile-content-box-title">{t('commercial-vehicle-choose-us-section-box3')}</div>
                            </div>
                            <div className="commercial-vehicle-choose-us-section-right-mobile-content-box">
                                <div className="commercial-vehicle-choose-us-section-right-mobile-content-box-img">
                                <img src="/images/tailored-loan-solutuions-icon.png" alt=""/>
                                </div>
                                <div className="commercial-vehicle-choose-us-section-right-mobile-content-box-title">{t('commercial-vehicle-choose-us-section-box4')}</div>
                            </div>
                        </motion.div>
                       
                </motion.div>
                    <motion.div 
                        className="commercial-vehicle-choose-us-section-mobile-button" 
                        style={{marginBottom: '20px'}}
                        variants={buttonVariants}
                        initial="hidden"
                        whileInView="visible"
                        whileHover="hover"
                        whileTap="tap"
                        viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                    >
                        <button className="btn-primary btn-big btn-small" onClick={onApplyNowClick}>{t('commercial-vehicle-choose-us-section-button')} &#8594;</button>
                    </motion.div>
        </section>
        </>
    )
}

export default CommercialVehicleChooseUsSection;